(function () {
  'use strict';

  if (window.StorefrontDiscountPrice) return;

  var CART_CREATE_MUTATION = [
    'mutation CartCreate($input: CartInput!) {',
    '  cartCreate(input: $input) {',
    '    cart {',
    '      id',
    '      discountCodes { code applicable }',
    '      lines(first: 5) {',
    '        nodes {',
    '          quantity',
    '          merchandise { ... on ProductVariant { id } }',
    '          cost {',
    '            amountPerQuantity { amount currencyCode }',
    '            totalAmount { amount currencyCode }',
    '          }',
    '        }',
    '      }',
    '    }',
    '    userErrors { field message }',
    '  }',
    '}',
  ].join('\n');

  function getConfig() {
    var cfg = window.__etrustedBundleApi || window.__storefrontApi || null;
    if (!cfg || !cfg.token || !cfg.domain) return null;
    return {
      token: String(cfg.token).trim(),
      domain: String(cfg.domain).trim(),
      apiVersion: cfg.apiVersion || '2024-07',
    };
  }

  function variantGid(variantId) {
    return 'gid://shopify/ProductVariant/' + String(variantId).trim();
  }

  function amountToCents(amount) {
    var value = Number(amount);
    if (!Number.isFinite(value) || value <= 0) return 0;
    return Math.round(value * 100);
  }

  function storefrontRequest(config, body) {
    var endpoint =
      'https://' + config.domain + '/api/' + config.apiVersion + '/graphql.json';

    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': config.token,
      },
      body: JSON.stringify(body),
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Storefront API request failed: ' + response.status);
      }
      return response.json();
    });
  }

  function pickLineSaleCents(cart, variantId) {
    var targetGid = variantGid(variantId);
    var nodes =
      cart && cart.lines && Array.isArray(cart.lines.nodes) ? cart.lines.nodes : [];

    var line =
      nodes.find(function (node) {
        var merchId =
          node && node.merchandise && node.merchandise.id
            ? String(node.merchandise.id)
            : '';
        return merchId === targetGid;
      }) || nodes[0];

    if (!line || !line.cost) return { saleCents: 0, listCents: 0 };

    var qty = Math.max(1, Number(line.quantity) || 1);
    var listCents = 0;
    var perQty = line.cost.amountPerQuantity && line.cost.amountPerQuantity.amount;
    if (perQty) listCents = amountToCents(perQty);

    var total = line.cost.totalAmount && line.cost.totalAmount.amount;
    if (total) {
      return {
        saleCents: Math.round(amountToCents(total) / qty),
        listCents: listCents,
      };
    }

    if (listCents) {
      return { saleCents: listCents, listCents: listCents };
    }

    return { saleCents: 0, listCents: 0 };
  }

  function fetchSaleCents(variantId, code) {
    var config = getConfig();
    if (!config) {
      return Promise.reject(new Error('Storefront API token not configured'));
    }

    var normalizedCode = String(code || '').trim();
    var normalizedVariantId = String(variantId || '').trim();
    if (!normalizedCode || !normalizedVariantId) {
      return Promise.reject(new Error('Missing variant or discount code'));
    }

    return storefrontRequest(config, {
      query: CART_CREATE_MUTATION,
      variables: {
        input: {
          lines: [
            {
              merchandiseId: variantGid(normalizedVariantId),
              quantity: 1,
            },
          ],
          discountCodes: [normalizedCode],
        },
      },
    }).then(function (payload) {
      if (payload.errors && payload.errors.length) {
        throw new Error(payload.errors[0].message || 'Storefront GraphQL error');
      }

      var result = payload.data && payload.data.cartCreate;
      if (!result) throw new Error('Invalid Storefront cartCreate response');

      var userErrors = Array.isArray(result.userErrors) ? result.userErrors : [];
      if (userErrors.length) {
        throw new Error(userErrors[0].message || 'Storefront cartCreate failed');
      }

      var cart = result.cart;
      if (!cart) throw new Error('Storefront cart missing');

      var codes = Array.isArray(cart.discountCodes) ? cart.discountCodes : [];
      var codeApplied = codes.some(function (entry) {
        return (
          entry &&
          entry.applicable !== false &&
          String(entry.code || '').trim().toUpperCase() === normalizedCode.toUpperCase()
        );
      });

      var prices = pickLineSaleCents(cart, normalizedVariantId);
      var saleCents = prices.saleCents;
      var listCents = prices.listCents;

      if (!saleCents) {
        throw new Error('Invalid Storefront discount price');
      }

      if (codes.length && !codeApplied && listCents > 0 && saleCents >= listCents) {
        throw new Error('Discount code not applicable');
      }

      return { saleCents: saleCents, listCents: listCents || saleCents };
    });
  }

  window.StorefrontDiscountPrice = {
    fetchSaleCents: fetchSaleCents,
  };
})();
